import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react';

import config from './config';
import {Provider} from 'react-redux'
 
import {store} from './store/storeRedux'
import AppRouter from './AppRouter';

import I18n from 'redux-i18n'
import {translations} from './components/translations'


export const App = () => {

    console.log("Enter into App.js")   
    
    return (
        <Auth0Provider
            domain=     {config.get('auth0.domain')}
            clientId=   {config.get('auth0.clientID')}
            redirectUri={config.get('auth0.callbackURL')}
            audience=   {config.get('auth0.audience')}
        >
            <Provider store={store}>
                <I18n translations={translations}>
                    <AppRouter />
                </I18n>
            </Provider>
        </Auth0Provider>
    )
}

export default App;
